import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="container-x py-32 text-center" data-testid="not-found-page">
      <p className="eyebrow mb-4">404</p>
      <h1 className="font-heading text-4xl text-amber-100">This plane does not exist</h1>
      <Link to="/" className="btn-outline mt-8" data-testid="not-found-home-link">Return home</Link>
    </div>
  );
}
